import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { FieldArray } from 'formik';
import ExpenseMapper from '../../utils/mapper/ExpenseMapper';

function AddMapping({ show, fields, setFieldValue, values, type }) {

    // Converter formato novo (objeto) para array unificado
    const [preValues, setPreValues] = useState(() => {
        if (values && typeof values === 'object' && !Array.isArray(values)) {
            // Novo formato: mescla header, lines e sapFields em um único array
            return [
                ...(values.header || []),
                ...(values.lines || []),
                ...(values.sapFields || [])
            ];
        } else {
            // Formato antigo ou novo já em array
            return values || [];
        }
    });

    const [showValidation, setShowValidation] = useState(false);
    const [validationResult, setValidationResult] = useState(null);

    function handleUpdate(pre = preValues) {
        const prepare = []

        for (let i = 0; i < pre.length; i++) {
            var v = pre[i];
            var obj = {
                from: document.getElementById(`mapping-${type}-from(${i})`).value,
                to: document.getElementById(`mapping-${type}-to(${i})`).value,
            }
            const cond = document.getElementById(`mapping-${type}-condition(${i})`).value
            if (cond === 'if') {
                obj.cond = {
                    operator: cond,
                    equal: document.getElementById(`mapping-${type}-conditionEqual(${i})`)?.value || '',
                    ifValue: document.getElementById(`mapping-${type}-conditionIfValue(${i})`)?.value || '',
                    elseValue: document.getElementById(`mapping-${type}-conditionElseValue(${i})`)?.value || ''
                }
            } else if (cond === 'array') {

                const values = []
                const condValues = v.cond?.values || []

                for (let index = 0; index < condValues.length; index++) {
                    values.push({
                        from: document.getElementById(`mapping-${type}-conditionFrom(${i})(${index})`)?.value || '',
                        to: document.getElementById(`mapping-${type}-conditionTo(${i})(${index})`)?.value || ''
                    })
                }

                obj.cond = {
                    operator: 'array',
                    values: values
                }
            }
            prepare.push(obj)
        }

        for (let i = 0; i < prepare.length; i++) {
            const v = prepare[i];
            document.getElementById(`mapping-${type}-from(${i})`).value = v.from
            document.getElementById(`mapping-${type}-to(${i})`).value = v.to
            if (v.cond === 'if') {
                document.getElementById(`mapping-${type}-condition(${i})`).value = v.cond.operator
                document.getElementById(`mapping-${type}-conditionEqual(${i})`).value = v.cond.equal
                document.getElementById(`mapping-${type}-conditionIfValue(${i})`).value = v.cond.ifValue
                document.getElementById(`mapping-${type}-conditionElseValue(${i})`).value = v.cond.elseValue
            } else if (v.cond === 'array') {
                v.values.forEach((value, index) => {
                    document.getElementById(`mapping-${type}-conditionFrom(${i})(${index})`).value = value.from
                    document.getElementById(`mapping-${type}-conditionTo(${i})(${index})`).value = value.to
                })
            }
        }

        setPreValues(prepare);
        return prepare;
    }

    function handleUpdateValues(pre = preValues) {
        console.log('values to be updated')
        console.log(pre)

        for (let i = 0; i < pre.length; i++) {
            const v = pre[i];
            console.log('updating: ' + i)
            console.log(v)
            document.getElementById(`mapping-${type}-from(${i})`).value = v.from
            document.getElementById(`mapping-${type}-to(${i})`).value = v.to
            if (v.cond?.operator === 'if') {
                document.getElementById(`mapping-${type}-condition(${i})`).value = v.cond.operator
                document.getElementById(`mapping-${type}-conditionEqual(${i})`).value = v.cond.equal
                document.getElementById(`mapping-${type}-conditionIfValue(${i})`).value = v.cond.ifValue
                document.getElementById(`mapping-${type}-conditionElseValue(${i})`).value = v.cond.elseValue
            } else if (v.cond?.operator === 'array') {
                for (let index = 0; index < v.cond.values.length; index++) {
                    const value = v.cond.values[index];
                    console.log('updating: ')
                    console.log(value)
                    document.getElementById(`mapping-${type}-conditionFrom(${i})(${index})`).value = value.from
                    document.getElementById(`mapping-${type}-conditionTo(${i})(${index})`).value = value.to

                }
            }

        }
    }

    function handleDelete(index) {
        const confirmDelete = window.confirm(
            "Tem certeza que deseja deletar este mapeamento?"
        );

        if (!confirmDelete) return;

        const prepare = []

        preValues.forEach((v, i) => {
            console.log(v)
            var obj = {
                from: document.getElementById(`mapping-${type}-from(${i})`).value,
                to: document.getElementById(`mapping-${type}-to(${i})`).value,
                cond: null
            }
            const cond = document.getElementById(`mapping-${type}-condition(${i})`).value
            if (cond === 'if') {
                obj.cond = {
                    operator: cond,
                    equal: document.getElementById(`mapping-${type}-conditionEqual(${i})`).value,
                    ifValue: document.getElementById(`mapping-${type}-conditionIfValue(${i})`).value,
                    elseValue: document.getElementById(`mapping-${type}-conditionElseValue(${i})`).value
                }
            } else if (cond === 'array') {
                obj.cond = {
                    operator: cond,
                    values: v.cond.values ? v.cond.values.map((value, index) => {
                        return {
                            from: document.getElementById(`mapping-${type}-conditionFrom(${i})(${index})`)?.value || '',
                            to: document.getElementById(`mapping-${type}-conditionTo(${i})(${index})`)?.value || ''
                        }
                    }) : []
                }
            }
            prepare.push(obj)
        })

        var filtred = prepare.filter((v, i) => i !== index)
        handleUpdateValues(filtred);
        setPreValues(filtred);
    }

    function handleAddArray(index) {
        const prepare = [];
        const updatedValues = handleUpdate();
        for (let i = 0; i < updatedValues.length; i++) {
            const v = updatedValues[i];
            if (i === index) {
                v.cond.values.push({ from: '', to: '' })
                prepare.push(v)
            } else {
                prepare.push(v);
            }
        }

        setPreValues(prepare);
    }

    function handleDeleteArray(index, i) {
        const confirmDelete = window.confirm(
            "Tem certeza que deseja deletar este item do array?"
        );

        if (!confirmDelete) return;

        console.log(index, i)
        const prepare = [];
        const updatedValues = handleUpdate();
        console.log('updatedValues');
        console.log(updatedValues);
        for (let j = 0; j < updatedValues.length; j++) {
            const v = updatedValues[j];
            if (j === index) {
                v.cond.values = v.cond.values.filter((value, idx) => idx !== i)
                prepare.push(v)
            } else {
                prepare.push(v);
            }
        }

        console.log('prepare')
        console.log(prepare)
        handleUpdateValues(prepare);
        setPreValues(prepare);
    }

    function handleSave() {
        const prepare = [];
        preValues.forEach((v, i) => {
            var obj = {
                from: document.getElementById(`mapping-${type}-from(${i})`).value,
                to: document.getElementById(`mapping-${type}-to(${i})`).value,
                cond: null
            }
            const cond = document.getElementById(`mapping-${type}-condition(${i})`).value
            if (cond === 'if') {
                obj.cond = {
                    operator: cond,
                    equal: document.getElementById(`mapping-${type}-conditionEqual(${i})`).value,
                    ifValue: document.getElementById(`mapping-${type}-conditionIfValue(${i})`).value,
                    elseValue: document.getElementById(`mapping-${type}-conditionElseValue(${i})`).value
                }
            } else if (cond === 'array') {
                obj.cond = {
                    operator: cond,
                    values: v.cond.values ? v.cond.values.map((value, index) => {
                        return {
                            from: document.getElementById(`mapping-${type}-conditionFrom(${i})(${index})`)?.value || '',
                            to: document.getElementById(`mapping-${type}-conditionTo(${i})(${index})`)?.value || ''
                        }
                    }) : []
                }
            }

            // Preservar campos adicionais (conditional, condition, description, etc)
            if (v.conditional !== undefined) obj.conditional = v.conditional;
            if (v.condition !== undefined) obj.condition = v.condition;
            if (v.description !== undefined) obj.description = v.description;

            prepare.push(obj)
        })
        setFieldValue(type, prepare.filter((v) => v.to !== ''))
    }

    function handleValidate() {
        // Aplica o mapeamento atual (sem dados mockados)
        const currentMappings = handleUpdate();

        setValidationResult({
            mappings: currentMappings
        });
        setShowValidation(true);
    }

    return (
        <Overlay onClick={() => {
            handleSave();
            show(false);
        }}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalHeader>
                    <ModalTitle>{type.toUpperCase()}</ModalTitle>
                    <CloseButton onClick={() => {
                        handleSave();
                        show(false);
                    }}>
                        <CloseIcon />
                    </CloseButton>
                </ModalHeader>

                <ModalBody>
                    <SectionTitle>
                        Mapeamentos Configurados ({preValues.length} regras)
                    </SectionTitle>

                    {preValues.length === 0 ? (
                        <EmptyState>
                            <EmptyIcon>📋</EmptyIcon>
                            <EmptyText>Nenhuma regra configurada</EmptyText>
                            <EmptySubtext>Clique em "Adicionar Regra" para começar</EmptySubtext>
                        </EmptyState>
                    ) : (
                        preValues.map((value, index) => (
                            <MappingCard key={index}>
                            <CardHeader>
                                <CardTitle>Regra {index + 1}</CardTitle>
                                <DeleteButton onClick={(e) => {
                                    e.preventDefault();
                                    handleDelete(index);
                                }}>
                                    <DeleteOutlineIcon style={{ fontSize: '18px' }} />
                                </DeleteButton>
                            </CardHeader>

                            <CardContent>
                                <FormRow>
                                    <FormGroup flex="1">
                                        <Label>De</Label>
                                        <Input
                                            type="text"
                                            id={`mapping-${type}-from(${index})`}
                                            defaultValue={value['from']}
                                            placeholder="Campo de origem (ex: document.reportCreationDate)"
                                        />
                                    </FormGroup>

                                    <FormGroup width="150px">
                                        <Label>Condição</Label>
                                        <Select
                                            onChange={() => handleUpdate()}
                                            defaultValue={value.cond?.operator || null}
                                            id={`mapping-${type}-condition(${index})`}
                                        >
                                            <option value="">Nenhuma</option>
                                            <option value="if">Se</option>
                                            <option value="array">Array</option>
                                        </Select>
                                    </FormGroup>

                                    <FormGroup flex="1">
                                        <Label>Para</Label>
                                        <Input
                                            type="text"
                                            id={`mapping-${type}-to(${index})`}
                                            defaultValue={value['to']}
                                            placeholder="Campo de destino (ex: document.taxDate)"
                                        />
                                    </FormGroup>
                                </FormRow>

                                {value.cond?.operator === 'if' && (
                                    <ConditionSection>
                                        <ConditionTitle>Condição IF</ConditionTitle>
                                        <FormRow>
                                            <FormGroup flex="1">
                                                <LabelSmall>Igual a</LabelSmall>
                                                <InputSmall
                                                    defaultValue={value.cond?.equal || ''}
                                                    id={`mapping-${type}-conditionEqual(${index})`}
                                                    placeholder="Valor"
                                                />
                                            </FormGroup>
                                            <FormGroup flex="1">
                                                <LabelSmall>Então</LabelSmall>
                                                <InputSmall
                                                    defaultValue={value.cond?.ifValue || ''}
                                                    id={`mapping-${type}-conditionIfValue(${index})`}
                                                    placeholder="Valor se verdadeiro"
                                                />
                                            </FormGroup>
                                            <FormGroup flex="1">
                                                <LabelSmall>Senão</LabelSmall>
                                                <InputSmall
                                                    defaultValue={value.cond?.elseValue || ''}
                                                    id={`mapping-${type}-conditionElseValue(${index})`}
                                                    placeholder="Valor se falso"
                                                />
                                            </FormGroup>
                                        </FormRow>
                                    </ConditionSection>
                                )}

                                {value.cond?.operator === 'array' && (
                                    <ConditionSection>
                                        <ConditionTitle>Mapeamento de Array</ConditionTitle>
                                        {value.cond?.values?.map((v, i) => (
                                            <ArrayRow key={i}>
                                                <FormGroup flex="1">
                                                    <LabelSmall>De</LabelSmall>
                                                    <InputSmall
                                                        defaultValue={v.from || ''}
                                                        id={`mapping-${type}-conditionFrom(${index})(${i})`}
                                                        placeholder="Valor origem"
                                                    />
                                                </FormGroup>
                                                <FormGroup flex="1">
                                                    <LabelSmall>Para</LabelSmall>
                                                    <InputSmall
                                                        defaultValue={v.to || ''}
                                                        id={`mapping-${type}-conditionTo(${index})(${i})`}
                                                        placeholder="Valor destino"
                                                    />
                                                </FormGroup>
                                                <ArrayDeleteButton
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleDeleteArray(index, i);
                                                    }}
                                                >
                                                    <DeleteOutlineIcon style={{ fontSize: '16px' }} />
                                                </ArrayDeleteButton>
                                            </ArrayRow>
                                        ))}
                                        <AddArrayButton
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleAddArray(index);
                                            }}
                                        >
                                            <AddIcon style={{ fontSize: '18px', marginRight: '6px' }} />
                                            Adicionar Mapeamento
                                        </AddArrayButton>
                                    </ConditionSection>
                                )}
                            </CardContent>
                        </MappingCard>
                    ))
                    )}
                </ModalBody>

                <ModalFooter>
                    <AddRuleButton
                        onClick={(e) => {
                            e.preventDefault();
                            setPreValues(old => [...old, { from: '', to: '' }]);
                        }}
                    >
                        <AddIcon style={{ marginRight: '8px' }} />
                        Adicionar Regra
                    </AddRuleButton>

                    <ValidateButton
                        onClick={(e) => {
                            e.preventDefault();
                            handleValidate();
                        }}
                    >
                        <CheckCircleIcon style={{ marginRight: '8px' }} />
                        Validar Mapeamento
                    </ValidateButton>

                    <CloseFooterButton
                        onClick={(e) => {
                            e.preventDefault();
                            handleSave();
                            show(false);
                        }}
                    >
                        Salvar e Fechar
                    </CloseFooterButton>
                </ModalFooter>
            </ModalContent>

            {showValidation && (
                <ValidationModal onClick={() => setShowValidation(false)}>
                    <ValidationContent onClick={(e) => e.stopPropagation()}>
                        <ValidationHeader>
                            <ValidationTitle>Mapeamentos Configurados</ValidationTitle>
                            <CloseButton onClick={() => setShowValidation(false)}>
                                <CloseIcon />
                            </CloseButton>
                        </ValidationHeader>
                        <ValidationBody>
                            <JsonSection>
                                <JsonTitle>📋 Regras de Mapeamento</JsonTitle>
                                <JsonPre>{JSON.stringify(validationResult?.mappings, null, 2)}</JsonPre>
                            </JsonSection>
                        </ValidationBody>
                    </ValidationContent>
                </ValidationModal>
            )}
        </Overlay>
    );
}

// Styled Components
const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    backdrop-filter: blur(4px);
`;

const ModalContent = styled.div`
    background: white;
    border-radius: 16px;
    width: 90%;
    max-width: 1200px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    overflow: hidden;
`;

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 32px;
    border-bottom: 2px solid #e8e8e8;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

const ModalTitle = styled.h2`
    margin: 0;
    color: white;
    font-size: 24px;
    font-weight: 700;
    font-family: 'Mulish', sans-serif;
`;

const CloseButton = styled.button`
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    color: white;

    &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: rotate(90deg);
    }
`;

const ModalBody = styled.div`
    padding: 32px;
    overflow-y: auto;
    flex: 1;
`;

const ModalFooter = styled.div`
    display: flex;
    gap: 12px;
    padding: 24px 32px;
    border-top: 2px solid #e8e8e8;
    background: #f8f9fa;
`;

const SectionTitle = styled.h3`
    font-size: 18px;
    font-weight: 700;
    color: #667eea;
    margin: 0 0 20px 0;
    padding-bottom: 12px;
    border-bottom: 2px solid #e8e8e8;
    font-family: 'Mulish', sans-serif;
`;

const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
`;

const EmptyIcon = styled.div`
    font-size: 64px;
    margin-bottom: 16px;
    opacity: 0.5;
`;

const EmptyText = styled.p`
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 8px 0;
    font-family: 'Mulish', sans-serif;
`;

const EmptySubtext = styled.p`
    font-size: 14px;
    color: #7f8c8d;
    margin: 0;
    font-family: 'Mulish', sans-serif;
`;

const MappingCard = styled.div`
    background: white;
    border: 2px solid #e8e8e8;
    border-radius: 12px;
    margin-bottom: 16px;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
        border-color: #667eea;
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
    }
`;

const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: #f8f9fa;
    border-bottom: 1px solid #e8e8e8;
`;

const CardTitle = styled.h4`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    font-family: 'Mulish', sans-serif;
`;

const DeleteButton = styled.button`
    background: #ff6b6b;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    font-family: 'Mulish', sans-serif;

    &:hover {
        background: #ff5252;
        transform: scale(1.05);
    }
`;

const CardContent = styled.div`
    padding: 20px;
`;

const FormRow = styled.div`
    display: flex;
    gap: 16px;
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
`;

const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    flex: ${props => props.flex || '0 0 auto'};
    width: ${props => props.width || 'auto'};
`;

const Label = styled.label`
    font-size: 14px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-family: 'Mulish', sans-serif;
`;

const LabelSmall = styled(Label)`
    font-size: 12px;
`;

const Input = styled.input`
    padding: 12px;
    border: 2px solid #e8e8e8;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Mulish', sans-serif;
    transition: all 0.3s ease;

    &:focus {
        outline: none;
        border-color: #667eea;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }
`;

const InputSmall = styled(Input)`
    padding: 8px;
    font-size: 13px;
`;

const Select = styled.select`
    padding: 12px;
    border: 2px solid #e8e8e8;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Mulish', sans-serif;
    background: white;
    cursor: pointer;
    transition: all 0.3s ease;

    &:focus {
        outline: none;
        border-color: #667eea;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }
`;

const ConditionSection = styled.div`
    background: #f8f9fa;
    border: 2px dashed #d1d5db;
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;
`;

const ConditionTitle = styled.h5`
    margin: 0 0 12px 0;
    font-size: 14px;
    font-weight: 600;
    color: #667eea;
    font-family: 'Mulish', sans-serif;
`;

const ArrayRow = styled.div`
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
    align-items: flex-end;
`;

const ArrayDeleteButton = styled.button`
    background: #ff6b6b;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    flex-shrink: 0;
    height: 38px;

    &:hover {
        background: #ff5252;
        transform: scale(1.05);
    }
`;

const AddArrayButton = styled.button`
    background: #667eea;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 10px 16px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    font-family: 'Mulish', sans-serif;

    &:hover {
        background: #5568d3;
        transform: translateY(-2px);
    }
`;

const AddRuleButton = styled.button`
    background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
    color: white;
    border: none;
    border-radius: 12px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    font-family: 'Mulish', sans-serif;
    box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3);

    &:hover {
        box-shadow: 0 6px 16px rgba(39, 174, 96, 0.4);
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }
`;

const ValidateButton = styled.button`
    background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%);
    color: white;
    border: none;
    border-radius: 12px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    font-family: 'Mulish', sans-serif;
    box-shadow: 0 4px 12px rgba(243, 156, 18, 0.3);

    &:hover {
        box-shadow: 0 6px 16px rgba(243, 156, 18, 0.4);
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }
`;

const CloseFooterButton = styled.button`
    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
    color: white;
    border: none;
    border-radius: 12px;
    padding: 12px 32px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: 'Mulish', sans-serif;
    box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);

    &:hover {
        box-shadow: 0 6px 16px rgba(52, 152, 219, 0.4);
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }
`;

// Validation Modal Styles
const ValidationModal = styled(Overlay)`
    z-index: 10000;
`;

const ValidationContent = styled(ModalContent)`
    max-width: 1400px;
    max-height: 95vh;
`;

const ValidationHeader = styled(ModalHeader)`
    background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%);
`;

const ValidationTitle = styled(ModalTitle)``;

const ValidationBody = styled.div`
    padding: 24px;
    overflow-y: auto;
    flex: 1;
`;

const JsonSection = styled.div`
    display: flex;
    flex-direction: column;
`;

const JsonTitle = styled.h3`
    font-size: 16px;
    font-weight: 700;
    color: #2c3e50;
    margin: 0 0 16px 0;
    font-family: 'Mulish', sans-serif;
`;

const JsonPre = styled.pre`
    background: #2c3e50;
    color: #ecf0f1;
    padding: 20px;
    border-radius: 12px;
    overflow-x: auto;
    font-size: 13px;
    font-family: 'Courier New', monospace;
    line-height: 1.6;
    margin: 0;
    flex: 1;
    max-height: 600px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #34495e;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #7f8c8d;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #95a5a6;
    }
`;

export default React.memo(AddMapping);
